<template>
    <!-- Hero -->
    <meta name="csrf-token" :content="csrfToken" />
    <!-- Page Content -->
    <div class="content">
        <SessionMessage />
        <div class="block-rounded block">
            <ul class="nav nav-tabs nav-tabs-block" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{ active: activeTab === 'single' }"
                        @click="setActiveTab('single')">{{ $t('single') }}</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{ active: activeTab === 'bulk' }" @click="setActiveTab('bulk')">{{
                        $t('bulk') }}</button>
                </li>
            </ul>
            <div class="block-content tab-content">
                <div v-if="activeTab === 'single'" class="tab-pane active show">
                    <ShipmentForm />
                </div>
                <div v-if="activeTab === 'bulk'" class="tab-pane active show">
                    <div class="container">
                        <div class="row mb-3">
                            <div class="col-lg-6 col-xl-6">
                                <div class="mb-4">
                                    <label class="form-label" for="client_id_example">{{ $t('input_client') }}</label>
                                    <Select v-if="users.length" v-model="bulkForm.client_id" :options="users" filter
                                        optionLabel="first_name" :placeholder="$t('placeholder.select_seller')" required
                                        class="w-full md:w-56">
                                        <!-- Dropdown option display -->
                                        <template #value="slotProps">
                                            <div v-if="slotProps.value" class="flex items-center">
                                                <img :alt="slotProps.value.last_name" :src=slotProps.value.avatar
                                                    class="w-8 h-8 me-2 rounded-full object-cover"
                                                    style="width: 32px" />
                                                <div>{{ slotProps.value.first_name }} {{
                                                    slotProps.value.last_name }}</div>
                                            </div>
                                            <span v-else>
                                                {{ slotProps.placeholder }}
                                            </span>
                                        </template>
                                        <template #option="slotProps">
                                            <div class="text-sm flex items-center text-sm gap-2">
                                                <img :alt="slotProps.option.last_name" :src=slotProps.option.avatar
                                                    class="w-8 h-8 rounded-full object-cover" style="width: 32px" />
                                                <div>{{ slotProps.option.first_name }} {{
                                                    slotProps.option.last_name }}</div>
                                            </div>
                                        </template>
                                    </Select>
                                </div>
                            </div>
                            <div class="col-lg-6 col-xl-6 overflow-hidden">
                                <div class="mb-4">
                                    <label class="form-label" for="example-file-input">{{ $t('input_file_upload')
                                    }}</label>
                                    <input class="form-control" type="file" @change="handleFileUpload"
                                        accept=".csv, .xlsx, .xls" :disabled="!isClientSelected" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table id="excelTable" class="table-sm table-vcenter js-dataTable-full fs-sm table">
                            <thead>
                                <tr id="tableHeaders">
                                    <!-- Table headers will be populated dynamically -->
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Table rows will be populated dynamically -->
                            </tbody>
                        </table>
                    </div>
                    <h2 class="content-heading border-bottom mb-4 pb-2"></h2>
                    <div class="d-flex justify-content-end mb-4">
                        <button @click="submitExcelData" :disabled="!isFileSelected || !isClientSelected || isLoading"
                            class="btn btn-sm btn-success me-1">
                            <i class="fa fa-fw fa-plus me-1"></i> {{ $t('button_submit') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END Page Content -->
</template>

<script>
import ShipmentForm from './components/ShipmentForm.vue';
import swal from '../../../utils/swal';
export default {
    mounted() {
        this.fetchUsers();
    },
    data() {
        return {
            csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            activeTab: 'single',
            users: [], // Populate this from API or props
            excelData: [],
            bulkForm: {
                client_id: '',
                file: null,
            },
            isLoading: false,
            isClientSelected: false,
            isFileSelected: false,
        };
    },
    components: {
        ShipmentForm
    },
    watch: {
        'bulkForm.client_id': function (newValue) {
            this.isClientSelected = !!newValue;
        }
    },
    methods: {
        setActiveTab(tab) {
            this.activeTab = tab;
        },
        fetchUsers() {
            $.ajax({
                url: '/get-all-clients',  // Replace with your endpoint
                method: 'GET',
                success: (data) => {
                    this.users = data;
                },
                error: (xhr, status, error) => {
                    console.error('Error fetching users:', error);
                }
            });
        },
        handleFileUpload(event) {
            const file = event.target.files[0];

            if (file) {
                this.bulkForm.file = file;
                this.isFileSelected = true;

                const reader = new FileReader();
                reader.onload = this.handleFileRead; // Ensure this method is triggered
                reader.readAsArrayBuffer(file);  // Read the file as an ArrayBuffer
            } else {
                this.isFileSelected = false;
            }
        },
        // Handle file reading and parse it using XLSX
        handleFileRead(event) {
            const data = event.target.result;
            const workbook = XLSX.read(data, { type: 'array' }); // Read the ArrayBuffer

            const sheetName = workbook.SheetNames[0]; // Get the first sheet name
            const sheet = workbook.Sheets[sheetName];

            if (sheet) {
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                console.log('Excel Data:', jsonData); // Check the data
                this.populateTable(jsonData);
            } else {
                console.error('Sheet not found');
            }
        },
        // Populate the table with data from the Excel file
        populateTable(data) {
            const tableHeaders = document.getElementById("tableHeaders");
            const tableBody = document.querySelector("#excelTable tbody");

            // Clear previous table content
            tableHeaders.innerHTML = '';
            tableBody.innerHTML = '';

            const headers = data[0]; // The first row is the header row
            // Create table headers
            headers.forEach(header => {
                const th = document.createElement("th");
                th.innerText = header || ' '; // Use a space if the header is empty
                tableHeaders.appendChild(th);
            });

            // Initialize excelData array with the data (skip the first row as it's headers)
            this.excelData = data.slice(1); // Initialize excelData with rows, excluding the headers

            // Process the rows of data
            for (let i = 1; i < data.length; i++) {
                const row = data[i];
                const tr = document.createElement("tr");

                // Process each cell in the row
                headers.forEach((header, colIndex) => {
                    const td = document.createElement("td");
                    let cellValue = row[colIndex]; // Get the value from the data

                    if (header === "receiver_sim_number" && cellValue !== undefined && cellValue !== '') {
                        cellValue = [cellValue]; // convert it to an array
                    }

                    // Handle null, undefined, or empty string and display as empty cell
                    td.innerText = (cellValue === null || cellValue === undefined || cellValue === '') ? '' : cellValue;

                    // Optionally, make certain columns editable
                    td.contentEditable = true;

                    // Add a class to specific columns if needed (example for receiver_sim_number)
                    if (header === "receiver_sim_number") {
                        td.classList.add('editable-cell');
                    }

                    // Listen for changes to the table cell and update the excelData array
                    td.addEventListener('blur', () => {
                        let newValue = td.textContent.trim();

                        if (header === "receiver_sim_number") {
                            newValue = [newValue]; // wrap again
                        }

                        this.updateExcelData(i - 1, colIndex, newValue); // Adjust rowIndex to match the excelData index
                    });

                    tr.appendChild(td);
                });

                tableBody.appendChild(tr);
            }
        },
        // Update excelData when a cell is modified
        updateExcelData(rowIndex, colIndex, newValue) {
            // Update the value in excelData
            this.excelData[rowIndex][colIndex] = newValue;
        },
        // Submit the form data
        submitExcelData() {
            this.isLoading = true;

            if (!this.excelData || this.excelData.length === 0) {
                this.$emit('notify', { type: 'danger', message: 'No data available to submit.' });
                this.isLoading = false;
                return;
            }

            const formData = new FormData();
            formData.append('excel_data', JSON.stringify(this.excelData));

            if (this.bulkForm.file && this.bulkForm.file instanceof File) {
                formData.append('file', this.bulkForm.file);
            } else {
                this.$emit('notify', { type: 'danger', message: 'Please select a file to upload.' });
                this.isLoading = false;
                return;
            }

            formData.append('client_id', this.bulkForm.client_id._id);
            formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));

            axios.post('/shipments/upload', formData)
                .then(response => {
                    swal.success(this.$t('message_excel_submitted'));
                    this.resetForm();
                    console.log('Excel data submitted successfully:', response.data);
                })
                .catch(error => {
                    let errorMessage = 'There was an error processing your request.';
                    if (error.response?.data?.message) {
                        errorMessage = error.response.data.message;
                    }
                    swal.error(this.$t('message_general_error'));
                    console.error('Error submitting Excel data:', error);
                    this.$emit('notify', { type: 'danger', message: errorMessage });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        resetForm() {
            this.bulkForm.client_id = '';
            this.bulkForm.file = null;
            this.isFileSelected = false;
            this.isClientSelected = false;
            this.excelData = [];
        },
        showError(message) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
            });
        },
    },
};
</script>
<style scoped>
.selectpicker {
    color: #acacac;
    /* Change to the desired color */
}

.selectpicker::placeholder {
    color: #ffffff;
    /* Change to the desired color */
}

.selectpicker option:checked {
    background-color: #f8f9fa;
    /* Change to the desired color */
    color: #ffffff;
    /* Change to the desired color */
}

/* Override hover color */
.selectpicker option:hover {
    background-color: #f8f9fa;
    /* Change to the desired color */
    color: #ffffff;
    /* Change to the desired color */
}

.btn-white {
    background-color: rgb(226, 226, 226);
    color: black;
    /* Ensuring text is readable */
}

.modal-body {
    overflow-y: auto;
    /* Enable vertical scrolling */
}

#excelTable {
    width: 100%;
    table-layout: auto;
}

#excelTable th,
#excelTable td {
    padding: 8px;
    /* Add padding for better spacing */
    border: 1px solid #ddd;
    /* Optional: Add a border to make it look clean */
    text-align: left;
    /* Align text to the left */
    white-space: nowrap;
    /* Prevent text wrapping within headers and cells */
    overflow: hidden;
    /* Hide overflowing content */
    text-overflow: ellipsis;
    /* Show ellipsis when content overflows */
}

/* Make sure table headers don't overlap or break in a weird way */
#excelTable th {
    word-wrap: normal;
    /* Disable word wrapping inside headers */
    white-space: nowrap;
    /* Prevent wrapping */
}

/* Allow horizontal scrolling on table overflow */
.table-responsive {
    overflow-x: auto;
    /* Enable horizontal scrolling if the table overflows */
}
</style>